(function(){
  if(window.__TOS_RSG_BOUND__) return;
  window.__TOS_RSG_BOUND__ = true;

  var countrySource = document.getElementById('tos-rsg-modal');
  var shopifyLiquidCountry = countrySource ? (countrySource.getAttribute('data-localization-country') || '') : '';
  var savedScrollY = 0;

  var sizes = [
    { us:'5', circumference:49, diameter:16, uk:'J / J½', europe:'49', br:'13', asia:'9', ch:'9' },
    { us:'6', circumference:52, diameter:17, uk:'L½', europe:'52', br:'15', asia:'12', ch:'12' },
    { us:'7', circumference:54, diameter:17, uk:'N½ / O', europe:'54 / 55', br:'17', asia:'14', ch:'14.5' },
    { us:'8', circumference:57, diameter:18, uk:'P½ / Q', europe:'57', br:'20', asia:'16', ch:'17' },
    { us:'9', circumference:60, diameter:19, uk:'R½ / S', europe:'59 / 60', br:'22', asia:'18', ch:'19.5' },
    { us:'10', circumference:62, diameter:20, uk:'T½', europe:'62', br:'25', asia:'20', ch:'22' },
    { us:'11', circumference:65, diameter:21, uk:'V½ / W', europe:'65', br:'27', asia:'23', ch:'24.5' },
    { us:'12', circumference:67, diameter:21, uk:'Y', europe:'67', br:'30', asia:'25', ch:'27' },
    { us:'13', circumference:70, diameter:22, uk:'Z / Z+1', europe:'70', br:'32', asia:'27', ch:'29.5' },
    { us:'14', circumference:72, diameter:23, uk:'Z+3', europe:'72', br:'34', asia:'29', ch:'32' }
  ];

  var countryMap = {
    US:{key:'us',label:'US',flag:'🇺🇸'}, CA:{key:'us',label:'CA',flag:'🇨🇦'},
    GB:{key:'uk',label:'UK',flag:'🇬🇧'}, IE:{key:'uk',label:'IE',flag:'🇮🇪'}, AU:{key:'uk',label:'AU',flag:'🇦🇺'}, NZ:{key:'uk',label:'NZ',flag:'🇳🇿'},
    BR:{key:'br',label:'BR',flag:'🇧🇷'},
    JP:{key:'asia',label:'JP',flag:'🇯🇵'}, KR:{key:'asia',label:'KR',flag:'🇰🇷'}, SG:{key:'asia',label:'SG',flag:'🇸🇬'}, HK:{key:'asia',label:'HK',flag:'🇭🇰'}, CN:{key:'asia',label:'CN',flag:'🇨🇳'},
    CH:{key:'ch',label:'CH',flag:'🇨🇭'},
    DE:{key:'europe',label:'DE',flag:'🇩🇪'}, FR:{key:'europe',label:'FR',flag:'🇫🇷'}, IT:{key:'europe',label:'IT',flag:'🇮🇹'}, ES:{key:'europe',label:'ES',flag:'🇪🇸'}, NL:{key:'europe',label:'NL',flag:'🇳🇱'}, BE:{key:'europe',label:'BE',flag:'🇧🇪'}, AT:{key:'europe',label:'AT',flag:'🇦🇹'}, DK:{key:'europe',label:'DK',flag:'🇩🇰'}, NO:{key:'europe',label:'NO',flag:'🇳🇴'}, SE:{key:'europe',label:'SE',flag:'🇸🇪'}, FI:{key:'europe',label:'FI',flag:'🇫🇮'}, PT:{key:'europe',label:'PT',flag:'🇵🇹'}, PL:{key:'europe',label:'PL',flag:'🇵🇱'}, GR:{key:'europe',label:'GR',flag:'🇬🇷'}, CZ:{key:'europe',label:'CZ',flag:'🇨🇿'}
  };

  function ensureModalAtBodyLevel(){
    var modal = document.getElementById('tos-rsg-modal');
    if(modal && modal.parentNode !== document.body){
      document.body.appendChild(modal);
    }
    return modal;
  }

  function detectCountry(){
    if(shopifyLiquidCountry) return String(shopifyLiquidCountry).toUpperCase();
    if(window.Shopify && window.Shopify.country) return String(window.Shopify.country).toUpperCase();

    var htmlLang = document.documentElement.lang || '';
    var htmlMatch = htmlLang.match(/-([A-Z]{2})/i);
    if(htmlMatch) return htmlMatch[1].toUpperCase();

    var navLang = navigator.language || '';
    var navMatch = navLang.match(/-([A-Z]{2})/i);
    if(navMatch) return navMatch[1].toUpperCase();

    return 'US';
  }

  function findSizeByCircumference(mm){
    for(var i = 0; i < sizes.length; i++){
      if(mm <= sizes[i].circumference) return sizes[i];
    }

    return sizes[sizes.length - 1];
  }

  var tutorialImage = '<img class="rsg-how__img" src="https://cdn.shopify.com/s/files/1/0688/4825/5207/files/d9710265-ae25-4d0c-b36e-399c4d3d9186.jpg?v=1778200760" alt="How to measure your ring size with string" loading="lazy">';

  function renderContent(){
    var country = detectCountry();
    var info = countryMap[country] || countryMap.US;
    var modal = ensureModalAtBodyLevel();
    var body = modal ? modal.querySelector('[data-tos-rsg-body]') : null;

    if(!body) return;

    var headers = [
      '<th>US / CA<br>Select this size</th>',
      '<th>Finger circ.<br>mm</th>',
      '<th>Inner diameter<br>mm approx.</th>',
      '<th>UK / IE / AU / NZ</th>',
      '<th>EU</th>',
      '<th>BR</th>',
      '<th>JP / KR / SG</th>',
      '<th>CH</th>'
    ];

    var rows = sizes.map(function(s){
      return '<tr data-us-size="'+s.us+'">'
        + '<td>'+s.us+'</td>'
        + '<td>'+s.circumference+'</td>'
        + '<td>'+s.diameter+'</td>'
        + '<td>'+s.uk+'</td>'
        + '<td>'+s.europe+'</td>'
        + '<td>'+s.br+'</td>'
        + '<td>'+s.asia+'</td>'
        + '<td>'+s.ch+'</td>'
        + '</tr>';
    }).join('');

    var detectedNote = info.key !== 'us'
      ? '<div class="rsg-detected">📍 We detected you are browsing from <strong>'+info.flag+' '+info.label+'</strong>. Your local reference size will be shown next to the US/CA size.</div>'
      : '';

    body.innerHTML =
      '<div class="rsg">'

      + '<div class="rsg-warn rsg-warn--yellow">'
      + '<span class="rsg-warn__icon">⭐</span>'
      + '<p>For the most accurate result, visit a jewellery store and ask them to measure your finger in <strong>US/CA ring size</strong>. This is the safest way to avoid size exchanges.</p>'
      + '</div>'

      + '<div class="rsg-warn rsg-warn--red">'
      + '<span class="rsg-warn__icon">🚫</span>'
      + '<p>Do not wrap a measuring tape around your finger. Measuring tape is usually too wide and can bend unevenly, which often gives an inaccurate ring size. Use string or a thin paper strip instead.</p>'
      + '</div>'

      + '<div class="rsg-how">'
      + '<div class="rsg-how__title">How to measure your ring size at home</div>'
      + '<div class="rsg-how__grid">'
      + tutorialImage
      + '<div>'
      + '<ol class="rsg-how__steps">'
      + '<li><strong>Wrap a string</strong> or a thin paper strip around the finger you want to wear the ring on. Keep it snug, but not tight.</li>'
      + '<li><strong>Mark the overlap point</strong> with a pen where the string or paper meets itself.</li>'
      + '<li><strong>Lay it flat on a ruler</strong> and measure the length in whole millimetres. This is your finger circumference.</li>'
      + '<li><strong>Enter the measurement below</strong>. If your measurement falls between two sizes, we recommend the next available US/CA size for comfort.</li>'
      + '</ol>'
      + '<div class="rsg-how__tips">'
      + '<p>Tips for better accuracy</p>'
      + '<ul>'
      + '<li>Measure at the end of the day, when fingers are usually slightly larger.</li>'
      + '<li>Do not measure when your hands are very cold or very hot.</li>'
      + '<li>Measure the exact finger where you plan to wear the ring.</li>'
      + '<li>Wider bands feel tighter, so the larger size is usually safer if you are between sizes.</li>'
      + '</ul>'
      + '</div>'
      + '</div>'
      + '</div>'
      + '</div>'

      + '<div class="rsg-calc">'
      + '<div class="rsg-calc__title">📐 Find your size — enter your finger circumference</div>'
      + '<div class="rsg-calc__row">'
      + '<input class="rsg-calc__input" id="rsg-mm-input" type="number" min="49" max="72" step="1" placeholder="62" inputmode="numeric">'
      + '<span class="rsg-calc__label">mm</span>'
      + '<button class="rsg-calc__btn" id="rsg-calc-btn" type="button">Find my size</button>'
      + '</div>'
      + '<div class="rsg-calc__error" id="rsg-calc-error">Please enter a whole millimetre measurement between 49 mm and 72 mm.</div>'
      + detectedNote
      + '<div class="rsg-calc__result" id="rsg-calc-result">'
      + '<div class="rsg-calc__result-title">Recommended ring size</div>'
      + '<div class="rsg-calc__featured" id="rsg-featured"></div>'
      + '<div class="rsg-calc__others" id="rsg-others"></div>'
      + '<p class="rsg-calc__note">The calculator rounds up to the next available US/CA size when the measurement falls between two sizes. This helps avoid choosing a ring that is too tight.</p>'
      + '</div>'
      + '</div>'

      + '<div class="rsg-exchange">'
      + '<strong>💚 Free ring size exchange — 1-Year Warranty</strong><br>'
      + 'If your ring does not fit perfectly, we offer a <strong>free size exchange</strong>. Please note: an exchange requires <strong>additional production and shipping time</strong> for the new ring to be delivered. We strongly recommend confirming your size before ordering.'
      + '</div>'

      + '<div class="rsg-section-title">International ring size conversion guide</div>'
      + '<p class="rsg-section-sub">'
      + 'Use the US/CA size as the reference when selecting your ring. International sizes are provided as an approximate guide only because ring size conversions vary between countries, manufacturers, ring width and internal profile.'
      + '</p>'

      + '<div class="rsg-table-wrap">'
      + '<table class="rsg-table">'
      + '<thead><tr>'+headers.join('')+'</tr></thead>'
      + '<tbody>'+rows+'</tbody>'
      + '</table>'
      + '</div>'

      + '<p class="rsg-note"><strong>Note:</strong> All millimetre values are rounded to make home measuring easier. Minor differences may occur between conversion charts. When in doubt, use the US/CA size as the purchase reference.</p>'

      + '</div>';

    bindCalculator(info);
  }

  function bindCalculator(info){
    var btn = document.getElementById('rsg-calc-btn');
    var input = document.getElementById('rsg-mm-input');
    var error = document.getElementById('rsg-calc-error');
    var resultBox = document.getElementById('rsg-calc-result');
    var featured = document.getElementById('rsg-featured');
    var others = document.getElementById('rsg-others');

    if(!btn || !input || !error || !resultBox || !featured || !others) return;

    function calculate(){
      var mm = parseInt(input.value, 10);

      if(!mm || mm < 49 || mm > 72){
        input.classList.add('is-error');
        error.classList.add('visible');
        resultBox.classList.remove('visible');
        return;
      }

      input.classList.remove('is-error');
      error.classList.remove('visible');

      var selected = findSizeByCircumference(mm);

      var tableRows = document.querySelectorAll('.rsg-table tbody tr');
      tableRows.forEach(function(row){
        row.classList.remove('highlight');

        if(row.getAttribute('data-us-size') === selected.us){
          row.classList.add('highlight');
        }
      });

      var featuredHtml =
        '<div class="rsg-calc__featured-card">'
        + '<p class="rsg-calc__featured-label">🇺🇸 / 🇨🇦 US/CA Size — Select this</p>'
        + '<div class="rsg-calc__featured-val">'+selected.us+'</div>'
        + '</div>';

      if(info.key !== 'us'){
        featuredHtml +=
          '<div class="rsg-calc__featured-card rsg-calc__featured-card--country">'
          + '<p class="rsg-calc__featured-label">'+info.flag+' '+info.label+' Local Reference</p>'
          + '<div class="rsg-calc__featured-val">'+selected[info.key]+'</div>'
          + '</div>';
      }

      featured.innerHTML = featuredHtml;

      var systems = [
        {label:'Circ. mm', value:selected.circumference, key:'circumference'},
        {label:'Diameter mm', value:selected.diameter, key:'diameter'},
        {label:'UK/IE/AU/NZ', value:selected.uk, key:'uk'},
        {label:'EU', value:selected.europe, key:'europe'},
        {label:'BR', value:selected.br, key:'br'},
        {label:'JP/KR/SG', value:selected.asia, key:'asia'},
        {label:'CH', value:selected.ch, key:'ch'}
      ];

      var othersHtml = systems
        .filter(function(system){
          return system.key !== info.key;
        })
        .map(function(system){
          return '<div class="rsg-calc__others-card">'
            + '<div class="rsg-calc__others-country">'+system.label+'</div>'
            + '<div class="rsg-calc__others-val">'+system.value+'</div>'
            + '</div>';
        })
        .join('');

      others.innerHTML = othersHtml;
      resultBox.classList.add('visible');
    }

    btn.addEventListener('click', calculate);

    input.addEventListener('keydown', function(event){
      if(event.key === 'Enter'){
        event.preventDefault();
        calculate();
      }
    });

    input.addEventListener('input', function(){
      input.classList.remove('is-error');
      error.classList.remove('visible');
    });
  }

  function lockPage(){
    savedScrollY = window.scrollY || document.documentElement.scrollTop || 0;
    document.documentElement.classList.add('tos-rsg-lock');
    document.body.classList.add('tos-rsg-lock');
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + savedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlockPage(){
    document.documentElement.classList.remove('tos-rsg-lock');
    document.body.classList.remove('tos-rsg-lock');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, savedScrollY || 0);
  }

  function openModal(modal){
    modal = ensureModalAtBodyLevel();
    if(!modal) return;

    if(document.activeElement && typeof document.activeElement.blur === 'function'){
      document.activeElement.blur();
    }

    renderContent();

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden','false');
    lockPage();
  }

  function closeModal(modal){
    if(!modal) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden','true');
    unlockPage();
  }

  renderContent();

  document.addEventListener('click', function(event){
    var openBtn = event.target.closest('[data-tos-rsg-open]');

    if(openBtn){
      event.preventDefault();
      openModal(document.querySelector(openBtn.getAttribute('data-target') || '#tos-rsg-modal'));
      return;
    }

    var closeEl = event.target.closest('[data-tos-rsg-close]');

    if(closeEl){
      event.preventDefault();
      closeModal(closeEl.closest('.tos-rsg-modal'));
    }
  });

  document.addEventListener('keydown', function(event){
    if(event.key !== 'Escape') return;

    var modal = document.querySelector('.tos-rsg-modal.is-open');

    if(modal){
      closeModal(modal);
    }
  });
})();

(function(){
  var lang=(document.documentElement.lang||navigator.language||'en').toLowerCase().split('-')[0];
  var t={
    cs:{btn:'📏 Pruvodce velikosti prstenu',close:'Zavrit pruvodce',title:'Pruvodce velikosti prstenu',sub:'Zmerte prst a najdete spravnou velikost',calcTitle:'📐 Najdete svou velikost — zadejte obvod prstu v mm',calcBtn:'Najit mou velikost',calcError:'Zadejte cele cislo v mm mezi 49 a 72.',resultTitle:'Doporucena velikost prstenu',calcNote:'Kalkulacka zaokrouhli na nejblizsi dostupnou velikost US/CA.',exchange:'💚 Vymena prstenu zdarma — Zaruka 1 rok',sectionTitle:'Mezinarodni konverze velikosti prstenu',note:'Vsechny hodnoty mm jsou zaokrouhleny pro snazsi mereni doma.'},
    hu:{btn:'📏 Gyurumeret-tablazat',close:'Gyurumeret-tablazat bezarasa',title:'Gyurumeret-tablazat',sub:'Merje meg az ujjat es talalja meg a megfelelo meretet',calcTitle:'📐 Talalja meg a meretet — adja meg az ujjkorumfogat mm-ben',calcBtn:'Meretem megtalalasa',calcError:'Adjon meg egesz szamot 49 es 72 mm kozott.',resultTitle:'Ajanlott gyurumeret',calcNote:'A kalkulator a kovetkezo elerheto US/CA meretre kerekiti fel.',exchange:'💚 Ingyenes gyurumeret-csere — 1 eves garancia',sectionTitle:'Nemzetkozi gyurumeret-konverzio tablazat',note:'Minden mm ertek kerekitett az otthoni mereshez.'},
    ro:{btn:'📏 Ghid de marimi inele',close:'Inchide ghidul',title:'Ghid de marimi inele',sub:'Masurati degetul si gasiti marimea potrivita',calcTitle:'📐 Gasiti marimea — introduceti circumferinta degetului in mm',calcBtn:'Gaseste marimea mea',calcError:'Introduceti un numar intreg intre 49 si 72 mm.',resultTitle:'Marimea inelului recomandata',calcNote:'Calculatorul rotunjeste la urmatoarea marime US/CA disponibila.',exchange:'💚 Schimb gratuit de marime — Garantie 1 an',sectionTitle:'Conversie internationala marimi inele',note:'Toate valorile mm sunt rotunjite pentru masurare mai usoara acasa.'},
    de:{btn:'📏 Ringgroessen-Tabelle',close:'Ringgroessen-Tabelle schliessen',title:'Ringgroessen-Tabelle',sub:'Messen Sie Ihren Finger und finden die richtige Groesse',calcTitle:'📐 Finden Sie Ihre Groesse — geben Sie den Fingerumfang in mm ein',calcBtn:'Meine Groesse finden',calcError:'Bitte geben Sie eine ganze Zahl zwischen 49 und 72 mm ein.',resultTitle:'Empfohlene Ringgroesse',calcNote:'Der Rechner rundet auf die naechste verfuegbare US/CA-Groesse auf.',exchange:'💚 Kostenloser Ringgroessen-Umtausch — 1 Jahr Garantie',sectionTitle:'Internationale Ringgroessen-Umrechnungstabelle',note:'Alle mm-Werte sind zur einfacheren Heimmessung gerundet.'},
    da:{btn:'📏 Ringstoerrelse-guide',close:'Luk ringstoerrelse-guide',title:'Ringstoerrelse-guide',sub:'Mal din finger og find den rigtige stoerrelse',calcTitle:'📐 Find din stoerrelse — indtast fingerens omkreds i mm',calcBtn:'Find min stoerrelse',calcError:'Indtast et helt tal mellem 49 og 72 mm.',resultTitle:'Anbefalet ringstoerrelse',calcNote:'Beregneren runder op til den naeste tilgaengelige US/CA-stoerrelse.',exchange:'💚 Gratis ringstoerrelse-bytte — 1 ars garanti',sectionTitle:'International ringstoerrelse-konverteringstabel',note:'Alle mm-vaerdier er afrundet for nemmere maling derhjemme.'},
    es:{btn:'📏 Guia de tallas de anillo',close:'Cerrar guia de tallas',title:'Guia de tallas de anillo',sub:'Mide tu dedo y encuentra la talla perfecta',calcTitle:'📐 Encuentra tu talla — introduce la circunferencia del dedo en mm',calcBtn:'Encontrar mi talla',calcError:'Introduce un numero entero entre 49 y 72 mm.',resultTitle:'Talla de anillo recomendada',calcNote:'La calculadora redondea a la siguiente talla US/CA disponible.',exchange:'💚 Cambio gratuito de talla — Garantia de 1 ano',sectionTitle:'Tabla de conversion internacional de tallas de anillo',note:'Todos los valores en mm estan redondeados para facilitar la medicion en casa.'},
    fi:{btn:'📏 Sormuskoko-opas',close:'Sulje sormuskoko-opas',title:'Sormuskoko-opas',sub:'Mittaa sormesi ja loyda oikea koko',calcTitle:'📐 Loyda kokosi — anna sormen ymparysmitta millimetreina',calcBtn:'Loyda kokoni',calcError:'Anna kokonainen luku valilla 49-72 mm.',resultTitle:'Suositeltu sormuskoko',calcNote:'Laskuri pyoristaa seuraavaan saatavilla olevaan US/CA-kokoon.',exchange:'💚 Ilmainen sormuskoon vaihto — 1 vuoden takuu',sectionTitle:'Kansainvalinen sormuskokojen muunnostaulukko',note:'Kaikki mm-arvot on pyoristetty kotimittauksen helpottamiseksi.'},
    fr:{btn:'📏 Guide des tailles de bague',close:'Fermer le guide des tailles',title:'Guide des tailles de bague',sub:'Mesurez votre doigt et trouvez votre taille ideale',calcTitle:'📐 Trouvez votre taille — entrez la circonference du doigt en mm',calcBtn:'Trouver ma taille',calcError:'Veuillez entrer un nombre entier entre 49 et 72 mm.',resultTitle:'Taille de bague recommandee',calcNote:'Le calculateur arrondit a la taille US/CA disponible suivante.',exchange:'💚 Echange de taille gratuit — Garantie 1 an',sectionTitle:'Tableau de conversion international des tailles de bague',note:'Toutes les valeurs en mm sont arrondies pour faciliter la mesure a domicile.'},
    nl:{btn:'📏 Ringmaat-gids',close:'Sluit ringmaat-gids',title:'Ringmaat-gids',sub:'Meet je vinger en vind de juiste maat',calcTitle:'📐 Vind je maat — voer de vingeromtrek in mm in',calcBtn:'Vind mijn maat',calcError:'Voer een geheel getal tussen 49 en 72 mm in.',resultTitle:'Aanbevolen ringmaat',calcNote:'De calculator rondt af op de volgende beschikbare US/CA-maat.',exchange:'💚 Gratis ringmaat-ruil — 1 jaar garantie',sectionTitle:'Internationale ringmaat-conversietabel',note:'Alle mm-waarden zijn afgerond om thuis meten makkelijker te maken.'},
    it:{btn:'📏 Guida alle misure degli anelli',close:'Chiudi guida alle misure',title:'Guida alle misure degli anelli',sub:'Misura il tuo dito e trova la misura giusta',calcTitle:'📐 Trova la tua misura — inserisci la circonferenza del dito in mm',calcBtn:'Trova la mia misura',calcError:'Inserisci un numero intero tra 49 e 72 mm.',resultTitle:'Misura anello consigliata',calcNote:'Il calcolatore arrotonda alla successiva misura US/CA disponibile.',exchange:'💚 Cambio misura gratuito — Garanzia di 1 anno',sectionTitle:'Tabella di conversione internazionale delle misure degli anelli',note:'Tutti i valori in mm sono arrotondati per facilitare la misurazione a casa.'},
    ja:{btn:'📏 リングサイズガイド',close:'リングサイズガイドを閉じる',title:'リングサイズガイド',sub:'指を測って最適なサイズを見つけましょう',calcTitle:'📐 サイズを見つける — 指の周囲長をmmで入力',calcBtn:'私のサイズを見つける',calcError:'49〜72mmの整数値を入力してください。',resultTitle:'推奨リングサイズ',calcNote:'計算機は次に利用可能なUS/CAサイズに切り上げます。',exchange:'💚 無料サイズ交換 — 1年保証',sectionTitle:'国際リングサイズ変換表',note:'すべてのmm値は自宅での測定を容易にするために丸められています。'},
    nb:{btn:'📏 Ringstoerrelse-guide',close:'Lukk ringstoerrelse-guide',title:'Ringstoerrelse-guide',sub:'Mal fingeren din og finn riktig stoerrelse',calcTitle:'📐 Finn stoerrelsen din — angi fingerens omkrets i mm',calcBtn:'Finn min stoerrelse',calcError:'Angi et heltall mellom 49 og 72 mm.',resultTitle:'Anbefalt ringstoerrelse',calcNote:'Kalkulatoren runder opp til neste tilgjengelige US/CA-stoerrelse.',exchange:'💚 Gratis ringstoerrelse-bytte — 1 ars garanti',sectionTitle:'Internasjonal ringstoerrelse-konverteringstabell',note:'Alle mm-verdier er avrundet for enklere maling hjemme.'},
    pl:{btn:'📏 Przewodnik rozmiarow pierscionkow',close:'Zamknij przewodnik rozmiarow',title:'Przewodnik rozmiarow pierscionkow',sub:'Zmierz palec i znajdz odpowiedni rozmiar',calcTitle:'📐 Znajdz swoj rozmiar — wprowadz obwod palca w mm',calcBtn:'Znajdz moj rozmiar',calcError:'Wprowadz liczbe calkowita miedzy 49 a 72 mm.',resultTitle:'Zalecany rozmiar pierscionka',calcNote:'Kalkulator zaokragla w gore do nastepnego dostepnego rozmiaru US/CA.',exchange:'💚 Bezplatna wymiana rozmiaru — 1 rok gwarancji',sectionTitle:'Miedzynarodowa tabela konwersji rozmiarow pierscionkow',note:'Wszystkie wartosci mm sa zaokraglone dla latwiejszego pomiaru w domu.'},
    pt:{btn:'📏 Guia de tamanhos de anel',close:'Fechar guia de tamanhos',title:'Guia de tamanhos de anel',sub:'Meca o seu dedo e encontre o tamanho perfeito',calcTitle:'📐 Encontre o seu tamanho — introduza a circunferencia do dedo em mm',calcBtn:'Encontrar o meu tamanho',calcError:'Introduza um numero inteiro entre 49 e 72 mm.',resultTitle:'Tamanho de anel recomendado',calcNote:'A calculadora arredonda para o proximo tamanho US/CA disponivel.',exchange:'💚 Troca de tamanho gratuita — Garantia de 1 ano',sectionTitle:'Tabela internacional de conversao de tamanhos de anel',note:'Todos os valores em mm estao arredondados para facilitar a medicao em casa.'},
    sv:{btn:'📏 Ringstorlek-guide',close:'Stang ringstorlek-guide',title:'Ringstorlek-guide',sub:'Mat ditt finger och hitta ratt storlek',calcTitle:'📐 Hitta din storlek — ange fingerns omkrets i mm',calcBtn:'Hitta min storlek',calcError:'Ange ett heltal mellan 49 och 72 mm.',resultTitle:'Rekommenderad ringstorlek',calcNote:'Kalkylatorn avrundar uppat till nasta tillgangliga US/CA-storlek.',exchange:'💚 Gratis ringstorlek-byte — 1 ars garanti',sectionTitle:'Internationell ringstorlek-konverteringstabell',note:'Alla mm-varden ar avrundade for att underlatta matning hemma.'}
  };
  var tr=t[lang];
  if(!tr)return;
  var btn=document.querySelector('.tos-rsg-btn');
  if(btn)btn.textContent=tr.btn;
  var closeBtn=document.querySelector('#tos-rsg-modal .tos-rsg-close');
  if(closeBtn)closeBtn.setAttribute('aria-label',tr.close);
  var titleEl=document.getElementById('tos-rsg-title');
  if(titleEl)titleEl.textContent=tr.title;
  var subEl=document.querySelector('#tos-rsg-modal .tos-rsg-sub');
  if(subEl)subEl.textContent=tr.sub;
  function translateBody(){
    var ct=document.querySelector('.rsg-calc__title');
    if(ct)ct.textContent=tr.calcTitle;
    var cb=document.getElementById('rsg-calc-btn');
    if(cb)cb.textContent=tr.calcBtn;
    var ce=document.getElementById('rsg-calc-error');
    if(ce)ce.textContent=tr.calcError;
    var rt=document.querySelector('.rsg-calc__result-title');
    if(rt)rt.textContent=tr.resultTitle;
    var cn=document.querySelector('.rsg-calc__note');
    if(cn)cn.textContent=tr.calcNote;
    var ex=document.querySelector('.rsg-exchange strong');
    if(ex)ex.textContent=tr.exchange;
    var st=document.querySelector('.rsg-section-title');
    if(st)st.textContent=tr.sectionTitle;
    var n=document.querySelector('.rsg-note');
    if(n)n.textContent=tr.note;
  }
  translateBody();
  var body=document.querySelector('[data-tos-rsg-body]');
  if(body&&window.MutationObserver){new MutationObserver(translateBody).observe(body,{childList:true});}
})();
